/* Prev/next arrows for a .product-grid--peek row (snippets/carousel-arrows.liquid).
   Targets whichever grid inside is visible, so brand-tabs panels and the
   recently-viewed refetch work without extra wiring. */
if (!customElements.get('carousel-arrows')) {
  customElements.define('carousel-arrows', class extends HTMLElement {
    connectedCallback() {
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.prev.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));
      // scroll doesn't bubble, but capture on an ancestor still sees it
      this.addEventListener('scroll', this.update, { capture: true, passive: true });
      // tab switches toggle [hidden]; lazy panels insert a grid later
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
      this.resizer = new ResizeObserver(this.update);
      this.resizer.observe(this);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizer?.disconnect();
    }

    grid() {
      return [...this.querySelectorAll('.product-grid--peek')].find((g) => g.offsetParent !== null);
    }

    go(dir) {
      const grid = this.grid();
      const item = grid?.querySelector('.product-grid__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
      grid.scrollBy({ left: dir * (item.offsetWidth + gap), behavior: 'smooth' });
    }

    update() {
      const grid = this.grid();
      const max = grid ? grid.scrollWidth - grid.clientWidth : 0;
      this.toggleAttribute('data-scrollable', max > 1);
      this.prev.disabled = !grid || grid.scrollLeft <= 1;
      this.next.disabled = !grid || grid.scrollLeft >= max - 1;
    }
  });
}
